export const ERROR_CODES = [
  "PATH_FORBIDDEN",
  "PATH_NOT_FOUND",
  "FILE_TOO_LARGE",
  "INVALID_ORIGIN",
  "RATE_LIMITED",
  "INVALID_ARGS",
  "FFMPEG_NOT_FOUND",
  "FFMPEG_FAILED",
  "PYTHON_NOT_FOUND",
  "PYTHON_SCRIPT_NOT_ALLOWED",
  "PYTHON_FAILED",
  "GPU_INSUFFICIENT_VRAM",
  "STORAGE_FULL",
  "QUEUE_FULL",
  "JOB_NOT_FOUND",
  "JOB_CANCELLED",
  "UPDATE_FAILED",
  "INTERNAL_ERROR",
] as const;

export type HelperErrorCode = (typeof ERROR_CODES)[number];

export function isHelperErrorCode(v: unknown): v is HelperErrorCode {
  return typeof v === "string" && (ERROR_CODES as readonly string[]).includes(v);
}

export interface HelperError {
  error: HelperErrorCode;
  message: string;
  details?: Record<string, unknown>;
  user_action: string;
  doc_url?: string;
}
